import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginAuthComponent } from '../../auth/login/login.component';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-headerfive',
  templateUrl: './headerfive.component.html',
  styleUrls: ['./headerfive.component.css']
})
export class HeaderfiveComponent implements OnInit {

  closeResult = '';


  constructor(private modalService: NgbModal) { }
  // navigation
  navmethod: boolean = true;
  toggleNav() {
    this.navmethod = !this.navmethod;
  }

  ngOnInit(): void {
  }
  
  open() {
    const modalRef = this.modalService.open(LoginAuthComponent);
    //modalRef.componentInstance.name = 'World';
  }




}
